"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var back_1 = require("../../icons/back");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SubHeader = function (_a) {
    var _b;
    var method = _a.method, onBack = _a.onBack, hasBackIcon = _a.hasBackIcon, oneDepositMethodOnly = _a.oneDepositMethodOnly, step = _a.step, currency = _a.currency, children = _a.children;
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            method && (react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
                hasBackIcon && (react_1.default.createElement("div", { className: styles_module_scss_1.default.back, onClick: onBack },
                    react_1.default.createElement(back_1.BackIcon, null))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.methodName }, oneDepositMethodOnly
                    ? t('deposit')
                    : "".concat(t('depositBy'), " ").concat(method.name)),
                (method === null || method === void 0 ? void 0 : method.category) !== 'crypto' &&
                    Object.keys(breakpoints).length > 0 &&
                    !breakpoints.mobile ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.pci },
                    t('paymentsSecurity'),
                    react_1.default.createElement("img", { src: "/img/payments/pci/pcidss.png", alt: "pcidss" }))) : null)),
            step === 'pay' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.amount },
                t('toppingUpWith'),
                " ",
                (0, apps_shared_1.getCurrencySymbol)(currency), (_b = formState.values) === null || _b === void 0 ? void 0 :
                _b.amount)),
            step === 'default' && children),
        method && (method === null || method === void 0 ? void 0 : method.category) !== 'crypto' && breakpoints.mobile ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.pci },
            t('paymentsSecurity'),
            react_1.default.createElement("img", { src: "/img/payments/pci/pcidss.png", alt: "pcidss" }))) : null));
};
exports.default = SubHeader;
